'use client'

import { ButtonPrimary } from '@fukku/button/Primary/ButtonPrimary'
import { Modal } from '@fukku/modal/Modal'
import { MODAL_TYPE, type ModalAPI } from '@fukku/modal/types'
import texts from '@fukku/styles/texts.module.scss'
import { useFormContext } from 'form-components'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useEffect, useMemo, useRef } from 'react'
import { FormFieldNames, TestIds } from '../../../constants'
import styles from './DoubleOptInSuccessFeedback.module.scss'

type DoubleOptInSuccessFeedbackProps = {
	onFeedbackSent?(): void
	readonly sendSuccessFeedback: boolean
}

export function DoubleOptInSuccessFeedback({
	onFeedbackSent = () => {},
	sendSuccessFeedback,
}: Readonly<DoubleOptInSuccessFeedbackProps>) {
	const { t } = useLabels()
	const modalRef = useRef<ModalAPI>(null)
	const { getValues } = useFormContext()

	const handleCloseFeedback = () => {
		onFeedbackSent()
	}

	const title = t('subscribe.modal.optin.title')
	const body = t('subscribe.modal.optin.bodycopy')
	const button = t('subscribe.modal.button')
	const emailPlaceholder = useMemo(
		() => getValues(FormFieldNames.Email),
		[sendSuccessFeedback]
	)

	useEffect(() => {
		if (sendSuccessFeedback) {
			modalRef.current?.show()
		}
	}, [sendSuccessFeedback])

	return (
		<Modal
			name='optin-feedback-modal'
			ref={modalRef}
			title={title}
			type={MODAL_TYPE.M}
			onClose={handleCloseFeedback}
			data-testid={TestIds.DoubleOptinContainter}
		>
			<h2 className={`${styles.title} ${texts.titleXL}`}>{title}</h2>
			<p className={styles.body}>
				<ClientLabel placeholderValues={{ 1: emailPlaceholder }}>
					{body}
				</ClientLabel>
			</p>
			<ButtonPrimary
				className={styles.button}
				fullWidth
				onClick={() => modalRef.current?.close()}
				data-testid={TestIds.DoubleOptinButton}
			>
				{button}
			</ButtonPrimary>
		</Modal>
	)
}
